import axios from 'axios'

const http = axios.create({
	xsrfCookieName: 'csrftoken',
	xsrfHeaderName: 'X-CSRFToken'
})

http.interceptors.response.use(function (response) {
	return response
}, function (error) {
  // Ignore user-initiated/canceled requests.
  if (error?.code === 'ERR_CANCELED') {
    return Promise.reject(error)
  }

  const status = error?.response?.status   

  // Only redirect when we actually have an HTTP status.
  if (status != null) {
    if (status === 403) {
      window.location.replace('/unauthorized/')
    } else if (status === 404) {
      window.location.replace('/not-found/')
    }
  }

  return Promise.reject(error)
})

export default http
